import Timer from 'react-compound-timer'

const Stopwatch = ({ startAt, endAt, units }) => {
  const startDate = new Date(startAt);
  const currentDate = endAt ? new Date(endAt) : new Date();

  // get total seconds between the times
  var delta = Math.abs(currentDate - startDate);

  return (
    <Timer
      startImmediately={!endAt}
      initialTime={delta}
      formatValue={value => value > 9 ? value : `0${value}`}
    >
      {() => (
        units ? (
          <React.Fragment>
            <Timer.Days formatValue={value => value ? `${value}${value > 1 ? " jours " : " jour "}` : ``} />
            <Timer.Hours formatValue={value => value ? `${value}${value > 1 ? " heures " : " heure "}` : ``} />
            <Timer.Minutes formatValue={value => value ? `${value}${value > 1 ? " minutes et " : " minute et "}` : ``} />
            <Timer.Seconds formatValue={value => value ? `${value}${value > 1 ? " secondes " : " seconde "}` : ``} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Timer.Days formatValue={value => value ? ((value > 9 ? value : `0${value}`) + `:`) : ``} />
            <Timer.Hours formatValue={value => (value > 9 ? value : `0${value}`) + `:`} />
            <Timer.Minutes formatValue={value => (value > 9 ? value : `0${value}`) + `:`} />
            <Timer.Seconds formatValue={value => value > 9 ? value : `0${value}`} />
          </React.Fragment>
        )
      )}
    </Timer>
  );
}

export default Stopwatch;
